<template>
    <ai-form-tag-box ref="formTagBoxRef" :callbacks="callbacks" :disabled="disabled" :ds="ds" :meta="meta" />
</template>
<script setup>
import AiFormTagBox from '@/components/card-component/ai-form-tag-box.vue';
import { inject, onMounted, ref } from 'vue';

const formTagBoxRef = ref();
const userData = inject('userData');
const props = defineProps({
    ds: {
        type: Array,
        default: () => [],
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null, getDictionary: null }),
    },
    meta: {
        type: Object,
        default: () => {},
    },
});
const onValueChanged = event => {
    if (event.value && event.value[0] && !userData.value['bal_id']) {
        const dr = formTagBoxRef.value?.tagBoxRef?.instance
            .option('items')
            .find(item => item['kodp'] === event.value[0]);
        if (dr) {
            Object.assign(userData.value, { bal_id: dr.kodp, bname: dr.name, bkod_ecls: 2 });
            props.callbacks.userDataChanged();
        }
    }
};
onMounted(() => formTagBoxRef.value?.tagBoxRef?.instance.on('valueChanged', onValueChanged));
</script>
